import React from 'react';
import clsx from 'clsx';
import {
	composeClasses,
	styled,
	type WithClasses,
	type WithOwnerState,
} from '@netx/core-components/Theme';
import {
	settingsPaneRowClasses,
	getSettingsPaneRowUtilityClass,
	SettingsPaneRowClasses,
	SETTINGS_PANE_ROW_CLASS_NAME,
} from './settingsPaneRowClasses';

type SettingsPaneRowOwnerState = WithClasses<
	SettingsPaneRowClasses,
	{disabled?: boolean; stacked?: boolean}
>;

const useUtilityClasses = (ownerState: SettingsPaneRowOwnerState) => {
	const {classes} = ownerState;

	const slots = {
		root: ['root'],
	};

	return composeClasses(slots, getSettingsPaneRowUtilityClass, classes);
};

const SettingsPaneRowRoot = styled('div', {
	name: SETTINGS_PANE_ROW_CLASS_NAME,
	slot: 'Root',
})(({theme, ownerState}: WithOwnerState<SettingsPaneRowOwnerState>) => ({
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'nowrap',
	width: '100%',
	flex: '0 0 auto',
	[`.${settingsPaneRowClasses.root} + &`]: {
		borderTop: `1px solid ${theme.palette.custom.border}`,
	},
	...(ownerState?.disabled && {
		opacity: 0.5,
		pointerEvents: 'none',
	}),
	...(ownerState?.stacked && {
		flexDirection: 'column',
		// '& > div:first-child': {
		// 	width: '100%',
		// },
	}),
	[theme.breakpoints.down('sm')]: {
		borderTop: 0,
		flexDirection: 'column',
		'& > div': {
			width: '100%',
		},
	},
}));

export interface SettingsPaneRowProps
	extends
		React.DetailedHTMLProps<
			React.HTMLAttributes<HTMLDivElement>,
			HTMLDivElement
		>,
		WithClasses<SettingsPaneRowClasses, React.PropsWithChildren<{}>> {
	stacked?: boolean;
	disabled?: boolean;
}

export const SettingsPaneRowPrimitive = ({
	classes: _classes,
	className,
	disabled,
	stacked,
	...props
}: SettingsPaneRowProps) => {
	const ownerState: SettingsPaneRowOwnerState = {
		classes: _classes,
		className,
		disabled,
		stacked,
	};

	const classes = useUtilityClasses(ownerState);

	return (
		<SettingsPaneRowRoot
			aria-disabled={disabled}
			className={clsx(classes.root, className)}
			{...props}
			ownerState={ownerState}
		/>
	);
};

export const SettingsPaneRow = SettingsPaneRowPrimitive;

export default SettingsPaneRow;
